import type {ReactElement} from 'react';
import React from 'react';
import type {StreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import type {PlanTableProps} from './plan-table.types';
import {PlanTable} from './plan-table';

export const planTableRegistration: StreamComponentRegistration<StreamComponentType.PLAN_TABLE, PlanTableProps> = {
  componentType: StreamComponentType.PLAN_TABLE,
  parseProps: (props: Record<string, unknown>): PlanTableProps => {
    return props as unknown as PlanTableProps;
  },
  render: (props: PlanTableProps): ReactElement => {
    return React.createElement(PlanTable, props);
  },
};
